// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TZeo","fullView":"styles_fullView__gTy68"};